export default "__VITE_ASSET__CYN1q7BJ__"